const imboxToggle = () => {
    const imbox = window._imbox || []

    return {
        on: ()=> { imbox.push(['showLauncher']) },
        off: ()=> { 
            imbox.push(['hideLauncher']) 
            imbox.push(['hideWidget']) 
        },
    }

}

export default imboxToggle